import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import RegisterComponent from '../../../Components/UserComponents/Register';
import {
  getAllApprovedAds,
  getAllApprovedJobs,
  getAllChapters,
  getAllKeywordsByQuery,
  resetKeywordSearchData,
} from '../../../Store/Actions';
import {
  appendOtherChapterOption,
  createSelectionOptionsUtil,
  getVisibleChapters,
  queryString,
} from '../../../Util/commonUtility';
import { getPbssInternationalById } from '../../../Store/Actions/pbssInternational';

const RegisterContainer = () => {
  const dispatch = useDispatch();
  const {allChapters} = useSelector(({chapters}) => chapters);
  const [chapterList, setChapterList] = useState([]);
  const {allKeywordsQueryData} = useSelector(({keywords}) => keywords);
  const [keywordsOptions, SetKeywordsOptions] = useState([]);
  const {getApprovedJobs} = useSelector(({jobs}) => jobs);
  const {getApprovedAds} = useSelector(({ads}) => ads);
  const [allApprovedJobsData, setAllApprovedJobsData] = useState([]);
  const [allApprovedAdsData, setAllApprovedAdsData] = useState([]);
  const [chaptersListForAnnouncements, setChaptersListForAnnouncements] =
    useState([]);
    const {allPbssInternational} = useSelector(
      ({pbssInternational}) => pbssInternational,
    );
  const [pbssInternationalData, setPbssInternationalData] = useState();
  useEffect(() => {
    dispatch(resetKeywordSearchData(false));
  }, []);

  useEffect(() => {
    if (allChapters) {
      const chapters = allChapters?.data?.chapters ?? [];
      const visibleChapters = getVisibleChapters(chapters);
      setChapterList(
        appendOtherChapterOption(
          createSelectionOptionsUtil(visibleChapters, 'id', 'name'),
          chapters,
        ),
      );
      setChaptersListForAnnouncements([
        {label: 'Select all', value: 'all'},
        ...createSelectionOptionsUtil(visibleChapters, 'id', 'name'),
      ]);
    } else {
      dispatch(getAllChapters());
    }
  }, [allChapters]);

  useEffect(() => {
    if (
      allPbssInternational &&
      allPbssInternational?.data?.pbssInternational &&
      allPbssInternational?.data?.pbssInternational.length > 0
    ) {
      setPbssInternationalData(allPbssInternational?.data?.pbssInternational[0]);
    }
  }, [allPbssInternational]);

  useEffect(() => {
    fetchPbssInternationalById();
  }, []);

  const fetchPbssInternationalById = () => {
    dispatch(getPbssInternationalById());
  };

  useEffect(() => {
    if (allKeywordsQueryData.forMaster) {
      SetKeywordsOptions(
        createSelectionOptionsUtil(
          allKeywordsQueryData.forMaster?.data?.keywords,
          'id',
          'name',
        ),
      );
    } else {
      dispatch(
        getAllKeywordsByQuery('name', 'ascend', queryString({status: 1}), {
          page: 1,
          pageCount: 1000,
        }),
      );
    }
  }, [allKeywordsQueryData.forMaster]);

  useEffect(() => {
    if (getApprovedJobs) {
      const Data = getApprovedJobs?.data?.jobs.slice(0, 4);
      setAllApprovedJobsData(Data);
    } else {
      dispatch(getAllApprovedJobs());
    }
  }, [getApprovedJobs]);

  useEffect(() => {
    if (getApprovedAds) {
      const Data = getApprovedAds?.data?.ads.slice(0, 4);
      setAllApprovedAdsData(Data);
    } else {
      dispatch(getAllApprovedAds());
    }
  }, [getApprovedAds]);
  return (
    <RegisterComponent
      chaptersList={chapterList}
      chaptersListForAnnouncements={chaptersListForAnnouncements}
      allApprovedJobsData={allApprovedJobsData}
      allApprovedAdsData={allApprovedAdsData}
      keywordsOptions={keywordsOptions}
      pbssInternationalData={pbssInternationalData}
    />
  );
};

export default RegisterContainer;
